import {setupKey} from '../../utils/eventSetup';

// Local paths and notes stay in the native client. Only metadata is joined into
// the in-memory Library model; this module never writes to the team cloud.
export function localLibraryRecord(file){
  const meta=file.metadata||{},draft=meta.uploadDraft||{};
  if(meta.isInstantClip||meta.entityType==='clip'||!meta.teamId)return null;
  const matchId=draft.resolvedMatchId||(draft.matchMode==='existing'?draft.selectedMatchId:'')||meta.matchId||'';
  return {id:'local:'+file.path,isLocal:true,path:file.path,teamId:meta.teamId,
    mapId:meta.mapId||'',mapName:meta.mapName||meta.mapId||'Map not set',matchId,
    calendarEventId:draft.calendarEventId||meta.calendarEventId||'',
    matchTitle:meta.matchTitle||draft.newMatchTitle||file.fileName,
    povName:draft.povName||meta.povName||(meta.mode==='coach'?"Coach's POV":file.fileName),
    fileName:file.fileName,sizeBytes:file.sizeBytes,createdAt:file.createdAt,
    matchPlayedAt:meta.matchPlayedAt||meta.startedAt||file.createdAt,
    status:file.recoverable?'Recoverable':'Local',noteCount:file.noteCount||0,
    uploadedCloudSummary:meta.uploadedCloudSummary||null};
}
export function mergeLocalLibraryMedia(media,locals,teams){
  const result={...media};
  locals.forEach(record=>{
    if(!teams[record.teamId])return;
    const current=result[record.teamId]||{videos:[],stats:[]};
    result[record.teamId]={...current,videos:[...(current.videos||[]),record]};
  });
  return result;
}

export function localRecordingsForSlot(records,teamId,event,slot){
  const key=setupKey(event,slot.id),matchId=slot.matchId||slot.localMatchId;
  return records.filter(record=>record.teamId===teamId&&record.mapId===slot.mapId&&
    (record.calendarEventId===key||(matchId&&record.matchId===matchId)));
}
